import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class AssignButtonView extends Component {
  static propTypes = {
    onClick: PropTypes.func
  };
  static defaultProps = {};

  render() {
    const { onClick, children } = this.props;
    return <Button onClick={onClick}> <Border>{children}</Border> </Button>;
  }
}

const Button = styled.section`
  display: flex;
  flex: none;
  height: 50px;
  background-color: ${props => props.theme.blueButton};
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  transition: 0.3s;
  font-size: 12px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const Border = styled.button`
padding: 7px 55px 6px;
border: 2px solid #fff;
border-radius: 20px;
color: white;
font-weight: 700;
cursor: pointer;
background: transparent;
&:focus {
  outline: none;
}
&:hover {
  background: white;
  color: ${props => props.theme.blueButton};
}
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/assign-button/AssignButtonView.js